<div class="gap-4"> @for (bid of myBids ; track $index)
    {
    <div class="w-full bg-white rounded-lg border-b border-gray-300 py-4 p-4 
        grid grid-cols-2  md:flex md:flex-row md:items-stretch ">

        <div class="flex flex-col  md:flex-row md:flex-1 ">

            <div class="hidden md:block w-24 h-24"> <img
                    [src]=" absoluteMediaUriService.getAbsoluteMediaUri(bid.itemImageUrl) || 'item-default.jpg'"
                    alt="bid.itemName + 'image'" class="w-full h-full object-cover rounded-lg"> </div>

            <div class="flex flex-col md:pl-2 w-full md:flex-1 ">
                <a [routerLink]="['/auctions', bid.auctionId, 'items', bid.itemId]">
                    <h3 class="text-[var(--dark-blue)] font-bold text-xl hover:underline cursor-pointer"
                        [innerHTML]="bid.itemName  | sanitizeHtmlText">
                    </h3>
                </a>
                <p class="text-[var(--fs-black)] md:mt-2 md:mb-2  hover:underline cursor-pointer"
                    [routerLink]="['/auction', bid.auctionId]">{{
                    bid.organizationName }}</p>
                <p class=" hidden md:block text-[var(--fs-black)] font-medium italic text-sm">{{
                    timeLeftService.getTimeLeft(bid.itemOpeningDate, bid.itemClosingDate) }}
                </p>
            </div>

            <div class="flex flex-col space-y-1 w-full md:flex-1">

                @if(bid.isLeader)
                {
                <div class=" w-36 ml-3">
                    <span
                        class="flex items-center bg-[var(--fs-forest)] text-white px-3 py-1 rounded-full text-xs font-semibold h-7 md:pl-5">
                        <fa-icon [icon]="faCrown" class="mr-1 text-sm"></fa-icon>
                        You're Leading
                    </span>
                </div>

                <p class="text-[var(--fs-black)] text-sm font-bold  md:pl-5 m-0">
                    <span class=" text-lg text-[var(--fs-black)]">
                        {{bid.leadingBid ? (bid.leadingBid | currency:'USD':'symbol':'1.2-2') : '-' }}</span>
                    <span class=" text-[var(--dark-blue)] text-sm font-bold"> Your Leading Bid</span>
                </p>

                <p class="text-[var(--fs-black)] text-sm font-bold  md:pl-5 m-0">
                    <span class=" text-lg text-[var(--fs-black)]">
                        {{ bid.myMaxBid || '-'}}</span>
                    <span class=" text-[var(--dark-blue)] text-sm font-bold"> Your Max Bid</span>
                </p>



                }@else{
                <p class="text-[var(--fs-black)] text-sm font-bold  md:pl-5 m-0">
                    <span class=" text-lg text-[var(--fs-black)]">
                        {{ bid.myMaxBid || '-'}}</span>
                    <span class=" text-[var(--dark-blue)] text-sm font-bold"> Your Bid</span>
                </p>

                }

                <div class="flex flex-row  items-center justify-between md:flex-col md:items-start md:gap-0 md:pl-5 ">
                    <p class="text-[var(--fs-black)] text-base md:text-lg font-semibold md:m-0 m-0 md:mt-2  ">
                        {{ bid.creditCard.type }} <span> {{ bid.creditCard.lastDigits }}</span>
                    </p>
                    <p class=" text-[var(--fs-blue)] cursor-pointer text-xs md:text-base m-0"
                        (click)="onOpenPopover($event, popover)">
                        Change Card
                    </p>

                    <p-popover #popover styleClass="!p-0 shadow-md rounded-lg border border-gray-200 mx-4 md:mx-0">
                        <div class="flex items-center gap-2 p-2 md:p-0">
                            <p-select [options]="cardOptions().slice(0, 4)" optionLabel="label" optionValue="value"
                                top="4" [(ngModel)]="selectedCard" placeholder="Select new card"
                                class="w-full text-sm"></p-select>

                            <p-button label="Change" size="small"
                                (click)="onPatchCoverTheFee(bid.id, bid.isCoverTheFee, selectedCard!); popover.hide()" />
                        </div>
                    </p-popover>
                </div>
            </div>
        </div>


        <div class="flex flex-col  space-y-1 items-end md:items-stretch">

            <div class="flex items-center order-2 md:order-none justify-end"> <span
                    class="text-[var(--panorama-gray)] text-sm font-medium "> Cover the fee
                </span>
                <!-- <p-inputSwitch class="scale-75" [(ngModel)]="bid.isCoverTheFee"
                    (onChange)="onPatchCoverTheFee(bid.id,  $event.checked, bid.creditCard.id)"></p-inputSwitch> -->

               <p-toggleSwitch
                    class="scale-75"
                    [(ngModel)]="bid.isCoverTheFee"
                    (onChange)="onPatchCoverTheFee(bid.id,  $event.checked, bid.creditCard.id)">
                    </p-toggleSwitch>                    
            </div>

            @if(bid.isCoverTheFee)
            {
            <ng-container>
                <p class="text-[var(--fs-black)] order-3 md:order-none text-sm font-bol">
                    <span class=" text-base md:text-lg text-[var(--fs-black)]">
                        {{ bid.estimatedFee ? (bid.estimatedFee | currency:'USD':'symbol':'1.2-2') : '-' }}</span>
                    <span class=" text-[var(--dark-blue)] text-xs md:text-sm font-bold"> Fee Covered</span>
                </p>

                <p
                    class="text-[var(--fs-black)] font-medium italic text-[10px] md:text-xs mt-2 order-4 md:order-none md:pl-0 pl-2">
                    {{bid.isLeader ? 'Based on your leading bid' : 'Based on your bid' }}

                    <span class="hidden md:block"> {{bid.isLeader ? bid.leadingBid : bid.myMaxBid}}
                        {{currency()}}</span>
                </p>
            </ng-container>
            }
            <div class=" flex  md:hidden w-40 order-1 md:order-none justify-end">
                <p class="text-[var(--fs-black)] font-medium italic text-sm ">{{
                    timeLeftService.getTimeLeft(bid.itemOpeningDate, bid.itemClosingDate) }}</p>
            </div>
        </div>
    </div>
    }
</div>